import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { setDatePickerModal } from '../actions/modalActions'
import { setMessageModal } from '../../actions/generalActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import Ink from 'react-ink';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'

// Include the locale utils designed for moment
import MomentLocaleUtils from 'react-day-picker/moment';

class DatePickerModal extends Component {
    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.cancelTap = this.cancelTap.bind(this);
        this.confirmTap = this.confirmTap.bind(this);
        this.state = {
            from: undefined,
            to: undefined,
        };
    }

    handleDayClick(day) {
        const range = DateUtils.addDayToRange(day, this.state);
        this.setState(range);
    }

    handleResetClick() {
        this.setState({
            from: undefined,
            to: undefined,
        });
    }

    cancelTap() {
        this.props.setDatePickerModal(false);
        this.setState({ from: undefined });
        this.setState({ to: undefined });
    }

    confirmTap() {

        if (this.state.from === undefined
            || this.state.to === undefined) {
            this.props.setMessageModal(true, this.props.getTranslation(resource.INVALID_DATE_SELECTED));
            return;
        }

        const callback = this.props.datePickerModal.callback;
        const dispatch = this.props.datePickerModal.dispatch;

        let callbackParams = [this.state.from, this.state.to];

        if (this.props.datePickerModal.callbackparams !== undefined) {
            this.props.datePickerModal.callbackparams.map(param => {
                callbackParams.push(param);
                return '';
            })
        }

        this.props.setDatePickerModal(false);
        this.setState({ from: undefined });
        this.setState({ to: undefined });

        if (callback !== null) {
            if (dispatch !== null) {
                dispatch(callback.apply(this, callbackParams));
            } else {
                callback.apply(this, callbackParams);
            }
        }
    }

    render() {
        const { from, to } = this.state;
        const modifiers = { start: from, end: to };
        return (
            <Modal className='datePickerModal'
                contentLabel=""
                isOpen={this.props.datePickerModal.show}
                style={properties.datePickerModalStyle}
            >
                <div className="datePickerModal_header">
                    <div className="header_top">
                    {this.props.getTranslation(resource.SELECT_START_AND_END_DATE)}
                    </div>
                </div>
                <div className="datePickerModal_content">
                    <div>
                        <DayPicker
                            className="Selectable"
                            onDayClick={this.handleDayClick}
                            selectedDays={[from, { from, to }]}
                            modifiers={modifiers}
                            showWeekNumbers={true}
                            localeUtils={MomentLocaleUtils}
                            locale="nl"
                        />
                    </div>
                    <Helmet>
                        <style>{`
  .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #f0f8ff !important;
    color: #4a90e2;
  }
  .Selectable .DayPicker-Day {
    border-radius: 0 !important;
  }
  .Selectable .DayPicker-Day--start {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  .Selectable .DayPicker-Day--end {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
`}</style>
                    </Helmet>
                </div>
                <div className="datePickerModal_footer">
                    <button className="btnPrint" onClick={this.confirmTap}>
                    {this.props.getTranslation(resource.PRINT_HISTORY)}
                            <Ink />
                    </button>
                    <button className="btnCancel" onClick={this.cancelTap} >
                    {this.props.getTranslation(resource.CANCEL)}
                            <Ink />
                    </button>
                </div>
            </Modal>
        )
    }
}

DatePickerModal.propTypes = {
}

function mapStateToProps(state) {
    return {
        datePickerModal: state.modalState.datePickerModal
    }
}

export default connect(mapStateToProps, {
    setDatePickerModal,
    setMessageModal,
    getTranslation
})(DatePickerModal)



// WEBPACK FOOTER //
// src/modal/components/DatePickerModal.jsx